import styles from './style.module.scss';
import { Element } from 'react-scroll';
import FadeIn from '/components/commonComponents/fadeIn';
import { WebPNativeImage } from '@/components/WebPImage';
import { src } from '@/utils/common';

const BrandCard = ({ title, desc, ...props }) => {
  return (
    <Element name={title}>
      <WebPNativeImage
        src={src('/img/index/brand-banner.webp')}
        alt="banner"
        crossOrigin="anonymous"
        className={styles.background}
      />
      <div className={styles.support}>
        <FadeIn>
          <div className={styles.title}>{title}</div>
          <div className={styles.desc}>{desc}</div>
        </FadeIn>
        {props.children && <FadeIn>{props.children}</FadeIn>}
      </div>
    </Element>
  );
};

export default BrandCard;
